module.exports = __webpack_public_path__ + "static/media/conference.1dbf25f2.png";